import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  motionTrafficData: [],
  isLoadingMotionTrafficData: false,
  blocks: [],
  isLoadingBlocks: false,
  healthStatusByCode: [],
  isLoadingHealthStatusByCode: false,
  healthStatusByBlockCode: [],
  isLoadingHealthStatusByBlockCode: false,
  healthStatusByLocationOrAsset: [],
  isLoadingHealthStatusByLocationOrAsset: false,
  floors: [],
  floorsName: [],
  isLoadingFloors: false,

  floorPlanOfflineCount: [],
  isLoadingFloorPlanOfflineCount: false,

  equipmentQuantityModalData: [],
  isLoadingEquipmentQuantityModalData: false,

  equipmentQuantityGatewayModalData: [],
  isLoadingEquipmentQuantityGatewayModalData: false,

  blockFailureModalData: [],
  isLoadingBlockFailureModalData: false,

  locationsByBlockCodeData: [],
  isLoadingLocationsByBlockCodeData: false,

  assetDisplayLevelsByBlock: [],
  isLoadingAssetDisplayLevelsByBlock: false,

  assetDisplayLevelAndLocationsByBlock: [],
  isLoadingAssetDisplayLevelAndLocationsByBlock: false,

  selectedTcCode: "",
  // isFloorPlanUpdated: false,
  selectedSiteCode: "",
  selectedBlock: "",
  selectedFaultType: null,
  isLoading: false,
  error: null,
  dashboardStatus: [],

  isLoadingBlockToFloorById: false,
  blockToFloorById: [],
  resolveStatusValue: 0,
  assetRemovedOrUpdated: 0,
};

export const getMotionTrafficData: any = createAsyncThunk(
  "content/getMotionTrafficData",
  async ({ blockCode, reportType }: any) => {
    const res = await axios.get(
      `/slpapp/Dashboard/GetMotionTrafficDataByBlockCode/${blockCode}/${reportType}`,
    );

    const data = await res.data;
    return data;
  },
);

export const getBlocks: any = createAsyncThunk(
  "content/getBlocks",
  async (params) => {
    const res = await axios.get(`/slpapp/Dashboard/getAllBlocksByCode`, {
      params: params,
    });
    const data = await res.data;
    return data;
  },
);

export const getHealthStatusByCode: any = createAsyncThunk(
  "content/getHealthStatusByCode",
  async (params) => {
    const res = await axios.get(`/slpapp/Dashboard/getHealthStatusByCode`, {
      params: params,
    });
    const data = await res.data;
    return data;
  },
);

export const getAssetsByLocationAndTypeSlice: any = createAsyncThunk(
  "content/getAssetsByLocationAndTypeSlice",
  async ({
    assetTypeId,
    PageNumber,
    pageSize,
    searchText = null,
    SortBy,
    SortDirection,
    tcCode = null,
    siteCode = null,
    blockCode = null,
  }: any) => {
    if (!assetTypeId) return;
    const res = await axios.get(`/slpapp/Asset/AssetsByLocationAndType`, {
      params: {
        assetTypeId,
        PageNumber,
        pageSize,
        searchText,
        SortBy,
        SortDirection,
        tcCode,
        siteCode,
        blockCode,
      },
    });
    const data = await res.data;

    return data;
  },
);

export const getAssetsByLocationAndTypeGatewaySlice: any = createAsyncThunk(
  "content/getAssetsByLocationAndTypeGatewaySlice",
  async ({
    assetTypeId,
    PageNumber,
    pageSize,
    searchText = null,
    SortBy,
    SortDirection,
    tcCode = null,
    siteCode = null,
    blockCode = null,
  }: any) => {
    if (!assetTypeId) return;
    const res = await axios.get(`/slpapp/Asset/AssetsByLocationAndType`, {
      params: {
        assetTypeId,
        PageNumber,
        pageSize,
        searchText,
        SortBy,
        SortDirection,
        tcCode,
        siteCode,
        blockCode,
      },
    });
    const data = await res.data;

    return data;
  },
);

export const getHealthStatusByBlockCode: any = createAsyncThunk(
  "content/getHealthStatusByBlockCode",
  async (blockCode) => {
    const res = await axios.get(
      `/slpapp/Dashboard/getHealthStatusByBlockCode/${blockCode}`,
    );
    const data = await res.data;
    return data;
  },
);

export const getHealthStatusByLocationOrAsset: any = createAsyncThunk(
  "content/getHealthStatusByLocationOrAsset",
  async ({
    tcCode = null,
    siteCode = null,
    blockCode = null,
    assetCode = null,
  }: any) => {
    const res = await axios.get(
      `/slpapp/Dashboard/getHealthStatusByLocationOrAsset`,
      {
        params: {
          tcCode,
          siteCode,
          blockCode,
          assetCode,
        },
      },
    );
    const data = await res.data?.data;
    return data;
  },
);

export const GetAllFloorsByBlockCodeWithFaultCount: any = createAsyncThunk(
  "content/GetAllFloorsByBlockCode",
  async ({ blockCode, PageNumber, PageSize }: any) => {
    const res = await axios.get(
      `/slpapp/BlockToFloor/getAllFloorsWithFaultCountByBlockCode`,
      {
        params: { blockCode, PageNumber, PageSize },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const getFloorPlanOfflineCount: any = createAsyncThunk(
  "content/getFloorPlanOfflineCount",
  async ({ blockCode, PageNumber, PageSize }: any) => {
    const res = await axios.get(
      `/slpapp/BlockToFloor/getFloorPlanOfflineCount`,
      {
        params: { blockCode, PageNumber, PageSize },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const GetAllFloorNameByBlockCode: any = createAsyncThunk(
  "content/GetAllFloorNameByBlockCode",
  async ({ blockCode, PageNumber, PageSize }: any) => {
    const res = await axios.get(
      `/slpapp/BlockToFloor/getAllFloorsWithFloorCodeByBlockCode`,
      {
        params: { blockCode, PageNumber, PageSize },
      },
    );
    const data = await res.data;
    return data;
  },
);

export const getBlockWithFailuresSlice: any = createAsyncThunk(
  "content/getBlockWithFailuresSlice",
  async ({
    failureType = null,
    pageNumber = null,
    searchText = null,
    pageSize = null,
    sortBy = null,
    sortDirection = null,
  }: any) => {
    const payload = {
      failureType,
      pageNumber,
      searchText,
      pageSize,
      sortBy,
      sortDirection,
    };

    const res = await axios.post(
      `/slpapp/Dashboard/BlockWithFailures`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    //  ;
    const data = await res?.data?.data;
    return data;
  },
);

export const getLocationsByBlockCode: any = createAsyncThunk(
  "content/getLocationsByBlockCode",
  async ({ blockCode }: any) => {
    const res = await axios.get(`/slpapp/Block/locationsByBlock`, {
      params: { blockCode },
    });

    const data = await res.data.data;
    return data;
  },
);

export const getAssetDisplayLevelsByBlock: any = createAsyncThunk(
  "content/getassetDisplayLevelsByBlock",
  async ({ blockCode, chartType }: any) => {
    const res = await axios.get(`/slpapp/Block/getassetDisplayLevelsByBlock`, {
      params: { blockCode, chartType },
    });

    const data = await res.data.data;
    return data;
  },
);

export const getassetDisplayLevelAndLocationsByBlock: any = createAsyncThunk(
  "content/getassetDisplayLevelAndLocationsByBlock",
  async ({ blockCode, chartType }: any) => {
    const res = await axios.get(
      `/slpapp/Block/getassetDisplayLevelAndLocationsByBlock`,
      {
        params: { blockCode, chartType },
      },
    );

    const data = await res.data.data;
    return data;
  },
);

export const getDashboardStatus: any = createAsyncThunk(
  "content/getDashboardStatus",
  async () => {
    const res = await axios(`http://localhost:3000/dashboard-status`);
    const data = await res.data;

    return data;
  },
);

export const addEditFloorWithBlockCode: any = createAsyncThunk(
  "content/addEditFloorWithBlockCode",
  async ({ blockCode, Id, FloorCode }: any) => {
    const res = await axios.post(
      `/slpapp/BlockToFloor`,
      {},
      {
        params: {
          blockCode,
          Id,
          FloorCode,
        },
      },
    );

    const data = await res?.data;
    return data;
  },
);

export const getBlockToFloorById: any = createAsyncThunk(
  "content/getBlockToFloorById",
  async ({ Id }: any) => {
    const res = await axios.get(`/slpapp/BlockToFloor/getBlockToFloorById`, {
      params: { Id },
    });

    const data = await res?.data;
    return data;
  },
);

export const rearrangeIndexFloorLevels = async (requestBody: any) => {
  const res = await axios.post(
    "/slpapp/BlockToFloor/RearrangeIndex",
    requestBody,
  );

  const data = res?.data;
  return data;
};

export const deleteBlockWithBlockToFloorId: any = createAsyncThunk(
  "content/deleteBlockWithBlockToFloorId",
  async ({ BlockToFloorId }: any) => {
    const res = await axios.delete(`/slpapp/BlockToFloor`, {
      params: { BlockToFloorId },
    });

    const data = await res?.data;
    return data;
  },
);
export const deleteAssetModel: any = createAsyncThunk(
  "content/deleteAssetModel",
  async ({ assetModelCode }: any) => {
    const res = await axios.delete(`/slpapp/AssetModel`, {
      params: { assetModelCode },
    });

    const data = await res.data.data;
    return data;
  },
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setSelectedTcCode(state, action) {
      state.selectedTcCode = action.payload;
    },
    setSelectedSiteCode(state, action) {
      state.selectedSiteCode = action.payload;
    },
    setSelectedBlock(state, action) {
      state.selectedBlock = action.payload;
    },
    setSelectedFaultType(state, action) {
      state.selectedFaultType = action.payload;
    },
    /*     setIsFloorPlanUpdated(state, action) {
      state.isFloorPlanUpdated = action.payload;
    }, */
    setResolveStatusValue(state, action) {
      state.resolveStatusValue = action.payload;
    },
    setAssetRemovedOrUpdated(state, action) {
      state.assetRemovedOrUpdated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMotionTrafficData.pending, (state) => {
      state.isLoadingMotionTrafficData = true;
    });
    builder.addCase(getMotionTrafficData.fulfilled, (state, action) => {
      state.isLoadingMotionTrafficData = false;
      state.motionTrafficData = action.payload;
    });
    builder.addCase(getMotionTrafficData.rejected, (state, action) => {
      state.isLoadingMotionTrafficData = false;
      state.error = action.error.message;
    });

    builder.addCase(getDashboardStatus.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDashboardStatus.fulfilled, (state, action) => {
      state.isLoading = false;
      state.dashboardStatus = action.payload;
    });
    builder.addCase(getDashboardStatus.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getBlocks.pending, (state) => {
      state.isLoadingBlocks = true;
    });
    builder.addCase(getBlocks.fulfilled, (state, action) => {
      state.isLoadingBlocks = false;
      state.blocks = action.payload;
    });
    builder.addCase(getBlocks.rejected, (state, action) => {
      state.isLoadingBlocks = false;
      state.error = action.error.message;
    });

    builder.addCase(getHealthStatusByCode.pending, (state) => {
      state.isLoadingHealthStatusByCode = true;
    });
    builder.addCase(getHealthStatusByCode.fulfilled, (state, action) => {
      state.isLoadingHealthStatusByCode = false;
      state.healthStatusByCode = action.payload;
    });
    builder.addCase(getHealthStatusByCode.rejected, (state, action) => {
      state.isLoadingHealthStatusByCode = false;
      state.error = action.error.message;
    });

    builder.addCase(getHealthStatusByBlockCode.pending, (state) => {
      state.isLoadingHealthStatusByBlockCode = true;
    });
    builder.addCase(getHealthStatusByBlockCode.fulfilled, (state, action) => {
      state.isLoadingHealthStatusByBlockCode = false;
      state.healthStatusByBlockCode = action.payload;
    });
    builder.addCase(getHealthStatusByBlockCode.rejected, (state, action) => {
      state.isLoadingHealthStatusByBlockCode = false;
      state.error = action.error.message;
    });

    builder.addCase(getHealthStatusByLocationOrAsset.pending, (state) => {
      state.isLoadingHealthStatusByLocationOrAsset = true;
    });
    builder.addCase(
      getHealthStatusByLocationOrAsset.fulfilled,
      (state, action) => {
        state.isLoadingHealthStatusByLocationOrAsset = false;
        state.healthStatusByLocationOrAsset = action.payload;
      },
    );
    builder.addCase(
      getHealthStatusByLocationOrAsset.rejected,
      (state, action) => {
        state.isLoadingHealthStatusByLocationOrAsset = false;
        state.error = action.error.message;
      },
    );

    builder.addCase(GetAllFloorsByBlockCodeWithFaultCount.pending, (state) => {
      state.isLoadingFloors = true;
    });
    builder.addCase(
      GetAllFloorsByBlockCodeWithFaultCount.fulfilled,
      (state, action) => {
        state.isLoadingFloors = false;
        state.floors = action.payload;
      },
    );
    builder.addCase(
      GetAllFloorsByBlockCodeWithFaultCount.rejected,
      (state, action) => {
        state.isLoadingFloors = false;
        state.error = action.error.message;
      },
    );

    builder.addCase(getFloorPlanOfflineCount.pending, (state) => {
      state.isLoadingFloorPlanOfflineCount = true;
    });
    builder.addCase(getFloorPlanOfflineCount.fulfilled, (state, action) => {
      state.isLoadingFloorPlanOfflineCount = false;
      state.floorPlanOfflineCount = action.payload;
    });
    builder.addCase(getFloorPlanOfflineCount.rejected, (state, action) => {
      state.isLoadingFloorPlanOfflineCount = false;
      state.error = action.error.message;
    });

    builder.addCase(GetAllFloorNameByBlockCode.pending, (state) => {
      state.isLoadingFloors = true;
    });
    builder.addCase(GetAllFloorNameByBlockCode.fulfilled, (state, action) => {
      state.isLoadingFloors = false;
      state.floorsName = action.payload;
    });
    builder.addCase(GetAllFloorNameByBlockCode.rejected, (state, action) => {
      state.isLoadingFloors = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetsByLocationAndTypeSlice.pending, (state) => {
      state.isLoadingEquipmentQuantityModalData = true;
    });
    builder.addCase(
      getAssetsByLocationAndTypeSlice.fulfilled,
      (state, action) => {
        state.isLoadingEquipmentQuantityModalData = false;
        state.equipmentQuantityModalData = action.payload;
      },
    );
    builder.addCase(
      getAssetsByLocationAndTypeSlice.rejected,
      (state, action) => {
        state.isLoadingEquipmentQuantityModalData = false;
        state.error = action.error.message;
      },
    );

    builder.addCase(getAssetsByLocationAndTypeGatewaySlice.pending, (state) => {
      state.isLoadingEquipmentQuantityGatewayModalData = true;
    });
    builder.addCase(
      getAssetsByLocationAndTypeGatewaySlice.fulfilled,
      (state, action) => {
        state.isLoadingEquipmentQuantityGatewayModalData = false;
        state.equipmentQuantityGatewayModalData = action.payload;
      },
    );
    builder.addCase(
      getAssetsByLocationAndTypeGatewaySlice.rejected,
      (state, action) => {
        state.isLoadingEquipmentQuantityGatewayModalData = false;
        state.error = action.error.message;
      },
    );

    builder.addCase(getBlockWithFailuresSlice.pending, (state) => {
      state.isLoadingBlockFailureModalData = true;
    });
    builder.addCase(getBlockWithFailuresSlice.fulfilled, (state, action) => {
      state.isLoadingBlockFailureModalData = false;
      state.blockFailureModalData = action.payload;
    });
    builder.addCase(getBlockWithFailuresSlice.rejected, (state, action) => {
      state.isLoadingBlockFailureModalData = false;
      state.error = action.error.message;
    });

    builder.addCase(getLocationsByBlockCode.pending, (state) => {
      state.isLoadingLocationsByBlockCodeData = true;
    });
    builder.addCase(getLocationsByBlockCode.fulfilled, (state, action) => {
      state.isLoadingLocationsByBlockCodeData = false;
      state.locationsByBlockCodeData = action.payload;
    });
    builder.addCase(getLocationsByBlockCode.rejected, (state, action) => {
      state.isLoadingLocationsByBlockCodeData = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetDisplayLevelsByBlock.pending, (state) => {
      state.isLoadingAssetDisplayLevelsByBlock = true;
    });
    builder.addCase(getAssetDisplayLevelsByBlock.fulfilled, (state, action) => {
      state.isLoadingAssetDisplayLevelsByBlock = false;
      state.assetDisplayLevelsByBlock = action.payload;
    });
    builder.addCase(getAssetDisplayLevelsByBlock.rejected, (state, action) => {
      state.isLoadingAssetDisplayLevelsByBlock = false;
      state.error = action.error.message;
    });

    builder.addCase(
      getassetDisplayLevelAndLocationsByBlock.pending,
      (state) => {
        state.isLoadingAssetDisplayLevelAndLocationsByBlock = true;
      },
    );
    builder.addCase(
      getassetDisplayLevelAndLocationsByBlock.fulfilled,
      (state, action) => {
        state.isLoadingAssetDisplayLevelAndLocationsByBlock = false;
        state.assetDisplayLevelAndLocationsByBlock = action.payload;
      },
    );
    builder.addCase(
      getassetDisplayLevelAndLocationsByBlock.rejected,
      (state, action) => {
        state.isLoadingAssetDisplayLevelAndLocationsByBlock = false;
        state.error = action.error.message;
      },
    );

    builder.addCase(getBlockToFloorById.pending, (state) => {
      state.isLoadingBlockToFloorById = true;
    });
    builder.addCase(getBlockToFloorById.fulfilled, (state, action) => {
      state.isLoadingBlockToFloorById = false;
      state.blockToFloorById = action.payload;
    });
    builder.addCase(getBlockToFloorById.rejected, (state, action) => {
      state.isLoadingBlockToFloorById = false;
      state.error = action.error.message;
    });
  },
});

export const {
  setSelectedTcCode,
  setSelectedSiteCode,
  setSelectedBlock,
  setSelectedFaultType,
  // setIsFloorPlanUpdated,
  setResolveStatusValue,
  setAssetRemovedOrUpdated,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
